<template>
  <small>
    <span >
      Photography, design and web development by Xavier Reyes Ochoa.
      {{(new Date()).getFullYear()}}.
      All rights reserved.
    </span>
  </small>

</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue